module.exports = __webpack_public_path__ + "static/media/notification.8363e1fa.svg";